import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccountSelectedGuard } from './guards/account-selected/account-selected.guard';
import { AuthAbcGuard } from './guards/auth-abc/auth-abc.guard';
import { AuthAdminGuard } from './guards/auth-admin/auth-admin.guard';
import { AutoLoginGuard } from './guards/auto-login/auto-login.guard';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full'
	},
	{
		path: 'abc',
		loadChildren: () => import('./pages/abc/abc.module').then(m => m.AbcPageModule),
		canActivate: [AuthAbcGuard]
	},
	{
		path: 'code',
		loadChildren: () => import('./pages/auth/code/code.module').then(m => m.CodePageModule),
		canActivate: [AuthAbcGuard]
	},
	{
		path: 'admin',
		canActivate: [AuthAdminGuard],          // solo admin autenticado
		canActivateChild: [AuthAdminGuard],     // idem para hijos
		children: [
			{
				path: '',
				canActivate: [AccountSelectedGuard],
				loadChildren: () => import('./pages/admin/account/account.module').then(m => m.AccountPageModule),
			},
			{
				path: 'accounts',
				loadChildren: () => import('./pages/admin/accounts/accounts.module').then(m => m.AccountsPageModule)
			},
		]
	},
	{
		path: 'login',
		loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginPageModule),
		canActivate: [AutoLoginGuard]
	},
	{
		path: 'login/:code',
		loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginPageModule),
		canActivate: [AutoLoginGuard]
	},
	{
		path: 'payment',
		loadChildren: () => import('./pages/auth/register/payment/payment.module').then(m => m.PaymentPageModule)
	},
	{
		path: 'create-account',
		loadChildren: () => import('./pages/auth/create-account/create-account.module').then(m => m.CreateAccountPageModule)
	},
	{
		path: 'account',
		loadChildren: () => import('./pages/admin/account/account.module').then(m => m.AccountPageModule)
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: PreloadAllModules,
		}),
	],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule { }
